// Integrations.tsx
import React from 'react';
import { Badge, Button, Form, Input } from 'antd';
import { Card, CardHeader, CardContent } from '@/shared/ui/Card';
import styles from './Integrations.module.css';

const Integrations: React.FC = () => (
  <div className={styles.wrapper}>
    <h3 className={styles.pageTitle}>System Integrations</h3>

    <div className={styles.alert}>
      <span className={styles.alertTitle}>
        Business Associate Agreement Required
      </span>
      <span className={styles.alertDescription}>
        All integrations must have signed BAAs on file before activation.
      </span>
    </div>

    {/* DICOMweb / QIDO-RS */}
    <Card>
      <CardHeader
        title="DICOMweb / QIDO-RS"
        description="Configure DICOM image retrieval and storage endpoints."
      />
      <CardContent>
        <Form layout="vertical">
          <Form.Item
            label={<span className={styles.label}>Endpoint URL</span>}
            name="dicomUrl"
            initialValue="https://dicom.icardio.ai/qido-rs"
          >
            <Input className={styles.input} />
          </Form.Item>

          <div className={styles.status}>
            <Badge status="success" />
            <span className={styles.statusText}>Connected</span>
          </div>
        </Form>
      </CardContent>
    </Card>

    {/* EMR Webhook */}
    <Card>
      <CardHeader
        title="EMR Webhook Integration"
        description="Send completed reports to your Electronic Medical Records system."
      />
      <CardContent>
        <Form layout="vertical">
          <Form.Item
            label={<span className={styles.label}>Webhook URL</span>}
            name="webhookUrl"
            initialValue="https://emr.hospital.com/**************"
          >
            <Input className={styles.input} />
          </Form.Item>

          <Button type="primary">Test Payload</Button>
        </Form>
      </CardContent>
    </Card>
  </div>
);

export default Integrations;
